import { useAuth, isSimpleMenu } from '@/auth/AuthContext';
import { HubTabs } from '@/components/HubTabs';
import Bom from '@/pages/mfg/Bom';
import BomList from '@/pages/mfg/BomList';

/** 部品表（一覧 / 構成を見る）— ひとつの画面。 */
export default function BomHub({ side = 'tree' }) {
  const { user } = useAuth();
  const simple = isSimpleMenu(user);
  const tabs = [
    { key: 'list', label: '部品表の一覧', node: <BomList />, visible: side === 'list' || simple },
    { key: 'tree', label: '構成を見る', node: <Bom />, visible: side === 'tree' || simple },
  ];
  return <HubTabs tabs={tabs} initial={side} testid="bom-hub" />;
}
